import {AxiosError} from 'axios'

/**
 * Devolve só o motivo que o servidor mandou (`message`, ou `msg` nas validações antigas), ou null.
 * Diferente de getApiErrorMessage, nunca cai no texto técnico do axios ("Request failed with
 * status code 422"), para o chamador escolher a própria mensagem padrão.
 */
export function getServerErrorMessage(error: unknown): string | null {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = (error as AxiosError<{message?: string; msg?: string}>).response?.data
    const msg = data?.message ?? data?.msg
    if (typeof msg === 'string' && msg.trim() !== '') {
      return msg
    }
  }
  return null
}

/**
 * Extracts a user-facing message from axios/API errors (e.g. Laravel 422 JSON `message`).
 */
export function getApiErrorMessage(error: unknown, fallback = 'Ocorreu um erro.'): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const ax = error as AxiosError<{message?: string}>
    const msg = ax.response?.data?.message
    if (typeof msg === 'string' && msg.trim() !== '') {
      return msg
    }
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return fallback
}
